module.exports = __webpack_public_path__ + "static/mango-5d8304be3577e43ecbcaec8644bc6a8a.png";